import React from "react";
import { Coffee, Icon, Utensils } from "lucide-react";
import { Flame, Star, Sparkles } from "lucide-react";

const FavouriteBar = ({ items = [], onSelect }) => {
  if (!items || items.length === 0) return null;
  const getBadge = (item) => {
    if (item.isStaffChoice) {
      return {
        icon: Star,
        label: "Staff Choice",
        color: "bg-yellowlight text-black",
      };
    }

    if (item.isNewItem) {
      return {
        icon: Sparkles,
        label: "New",
        color: "bg-green-500 text-white",
      };
    }

    if (item.orderCount >= 5) {
      return {
        icon: Flame,
        label: "Popular",
        color: "bg-red-500 text-white",
      };
    }

    return null;
  };

  return (
    <div className="w-full overflow-x-auto scrollbar-thin">
      <div className="flex gap-4 px-4 py-0 min-w-max">
        {items.map((item) => {
          const badge = getBadge(item);
          const Icon = badge?.icon;

          return (
            <div
              key={item._id}
              onClick={() => onSelect(item)}
              className="
                relative
                w-[170px] min-h-[240px]
                bg-darkbg rounded-xl
                shadow-md hover:shadow-xl
                transition-all duration-300
                cursor-pointer flex flex-col
                overflow-hidden
              "
            >
              {/* BADGE */}
              {badge && (
                <span
                  className={`absolute top-2 left-2 flex items-center gap-1 text-xs px-2 py-1 rounded-full font-semibold ${badge.color}`}
                >
                  {Icon && <Icon size={12} />}
                  {badge.label}
                </span>
              )}
              {/* IMAGE */}
              <div className="h-[140px] w-full bg-gray-100 overflow-hidden flex items-center justify-center">
                <img
                  src={item.image || "/saigonstar/saigonstar_sqr.webp"}
                  alt={item.title}
                  className="w-full h-full object-cover hover:scale-110 transition duration-300"
                />
              </div>
              {/* CONTENT */}
              <div className="p-4 flex flex-col justify-between flex-1">
                <p className="text-sm font-semibold text-gray-800 uppercase tracking-wide">
                  {item.title}
                </p>

                <p className="text-sm text-gray-500 mt-2">
                  from ${item.price.toFixed(2)}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FavouriteBar;
